module.exports = __webpack_public_path__ + "static/fonts/Fact-CondensedExtraBold.dad0611.ttf";